import React, { useCallback } from 'react';
import cx from 'classnames';
import { useSelector } from 'react-redux';

import { assignJourneyOwner } from 'modules/tasks/http';
import { useTasksFiltersContext } from 'modules/tasks/filters/context';
import { useAssignOwnerContext, openAssignOwnerModal } from 'modules/tasks/assign-owner/context';

const t = {
  take: 'Take',
  separator: ' | ',
  no_owner: 'No owner',
};

const Owner = React.memo(({ className, owner, journeyId, isSelected, isOpen }) => {
  const { id: userId } = useSelector((state) => state.me) || {};
  const { filters } = useTasksFiltersContext();
  const { dispatch } = useAssignOwnerContext();

  const hideComponent = userId && filters?.handled_by?.id === userId;
  const showTake = (isSelected || isOpen) && owner?.id !== userId;
  const name = owner?.name ? owner.name : t.no_owner;

  const handleTakeClick = useCallback(
    (event) => {
      event.stopPropagation();
      assignJourneyOwner({ journeyId, agentId: userId });
    },
    [journeyId, userId]
  );

  const handleNameClick = useCallback(
    (event) => {
      event.stopPropagation();
      dispatch(openAssignOwnerModal({ journeyIds: [journeyId] }));
    },
    [dispatch, journeyId]
  );

  if (hideComponent) return null;
  return (
    <div className={className}>
      {showTake && (
        <>
          <span
            className={cx('item', { selected: isSelected, open: isOpen })}
            onClick={handleTakeClick}
          >
            {t.take}
          </span>
          <span>{t.separator}</span>
        </>
      )}
      <span
        className={cx('item', { selected: isSelected, open: isOpen })}
        onClick={handleNameClick}
      >
        {name}
      </span>
    </div>
  );
});

export default Owner;
